import { Controller } from "@hotwired/stimulus"

// Shows a block of markup on demand and hides the trigger that asked for it.
// Used for the "Standort hinzufügen" form, which carries a full map and should not
// occupy the page until it is actually wanted — nor be loaded: the form sits in a lazy
// Turbo frame inside the content, which this switches to eager when the content opens
// (a lazy frame's IntersectionObserver is not something to rely on in a background tab).
export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    // The form arrives after the click, so the first field can only be focused then.
    this.onFrameLoad = () => {
      if (!this.contentTarget.classList.contains("hidden")) this.focusFirstField()
    }
    this.contentTarget.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    this.contentTarget.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    const open = !this.contentTarget.classList.contains("hidden")
    if (this.hasTriggerTarget) this.triggerTarget.classList.toggle("hidden", open)
    if (open) {
      this.loadFrames()
      this.focusFirstField()
    }
  }

  loadFrames() {
    this.contentTarget.querySelectorAll('turbo-frame[loading="lazy"]').forEach((frame) => {
      frame.setAttribute("loading", "eager")
    })
  }

  focusFirstField() {
    const field = this.contentTarget.querySelector("input:not([type=hidden]), select, textarea")
    if (field) field.focus()
  }
}
